import React, { useState } from 'react';
import { useSpeech, MicButton, Listening, parseReadiness } from './voice';

// Hands-free first tap of the day: say how you feel; Mirror picks the readiness (and any barriers you mention).
export function VoiceReadiness({ onHeard }) {
  const [heard, setHeard] = useState(null);
  const sp = useSpeech((text, isFinal) => {
    const r = parseReadiness(text);
    setHeard({ text, ...r });
    if (isFinal) onHeard(r);
  });
  if (!sp.supported) return null;
  return (
    <div className="fl-voice-ready" data-testid="fl-ready-voice">
      <MicButton listening={sp.listening} onClick={sp.toggle} label="Say how ready you feel" testId="fl-ready-voice-mic" />
      <div>
        {sp.listening ? <Listening testId="fl-ready-voice-listening">Listening — say “ready”, “could use support” or “not confident yet”</Listening>
          : heard ? <p className="fl-small" style={{ margin: 0 }} data-testid="fl-ready-voice-heard">Heard: “{heard.text}”{heard.readiness ? ` → ${heard.readiness}` : ' — try “ready”, “could use support” or “not confident yet”'}{heard.barriers.length ? ` · ${heard.barriers.join(', ')}` : ''}</p>
            : <p className="fl-small" style={{ margin: 0 }}>Or just say it — “I'm ready” · “could use support, I need the procedure” · “not confident yet”</p>}
        {sp.error && <span className="fl-small fl-cam-msg" style={{ margin: 0 }} data-testid="fl-ready-voice-error">{sp.error}</span>}
      </div>
    </div>
  );
}
